module.exports = __webpack_public_path__ + "static/media/ic_info.a83846df.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/SpaceTypeSelect/ic_info.svg
// module id = 1495
// module chunks = 2